<cas-button color="accent"
            btnText="Request Activation"
            (clickAction)="sendActivationRequest()"
            *ngIf="canRequestActivation"
            [disabled]="isForcedDisabled || !isCellularDeviceValid || !jobNumber"></cas-button>
<span *ngIf="!canRequestActivation && !isActive">An activation request has been submitted</span>